    // Initialize paths for animation
    function initializePaths($container) {
        const $paths = $container.find('path');
        $paths.each(function () {
            const length = this.getTotalLength();
            $(this).css({
                strokeDasharray: length,
                strokeDashoffset: length,
                transition: 'none',
                opacity: 0,
                visibility: 'hidden',
            });
        });
    }

    // Trigger animation for paths
    function animatePaths($container) {
        const $paths = $container.find('path');
        $paths.each(function (index) {
            const $path = $(this);
            setTimeout(function () {
                $path.css({
                    visibility: 'visible',
                    transition: 'stroke-dashoffset 0.3s ease, opacity 0s',
                    strokeDashoffset: 0,
                    opacity: 1,
                });
            }, index * 200);
        });
    }

    // Set up a MutationObserver for each .block-item
    const observer = new MutationObserver(function (mutationsList) {
        mutationsList.forEach(function (mutation) {
            if (
                mutation.type === "attributes" &&
                mutation.attributeName === "class" &&
                $(mutation.target).hasClass("animated")
            ) {
                console.log('Mutations observed', mutation);

                const $blockItem = $(mutation.target);
                const $container = $blockItem.find('.line-animation-container');

                if ($container.length) {
                    const index = $('.block-item').index($blockItem);
                    const delay = 1500 + index * 600;

                    setTimeout(() => {
                        $container.css('display', 'block');
                        initializePaths($container);
                        animatePaths($container);
                    }, delay);
                }
            }
        });
    });

    $('.block-item').each(function () {
        const blockNode = this;
        observer.observe(blockNode, { attributes: true });
    });


